/**
 * Shared guest-link attrs so Grubhub (and any other http(s) destination)
 * always opens in a new tab. Roma money pages, choosers, and homepage CTAs
 * should import this instead of inlining target/rel.
 */
export function isExternalHttpHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}

export function isGrubhubHref(href: string): boolean {
  return /grubhub\.com/i.test(href);
}

export function externalLinkProps(href: string): {
  target?: "_blank";
  rel?: "noopener noreferrer";
} {
  if (!isExternalHttpHref(href) && !isGrubhubHref(href)) {
    return {};
  }

  return {
    target: "_blank",
    rel: "noopener noreferrer",
  };
}
